export default __webpack_public_path__ + "static/media/guia-mobile-2.684b1f5e.png";